import React, { type ReactNode } from 'react';

import { Text, TextProps } from '@atlaskit/primitives/compiled';

type KnowledgeCardSecondaryDescriptionProps = {
	children: ReactNode;
	color?: TextProps['color'];
} & TextProps;

export const KnowledgeCardSecondaryDescription = ({
	children,
	color = 'color.text.subtle',
	...textProps
}: KnowledgeCardSecondaryDescriptionProps) => {
	return (
		<Text color={color} {...textProps}>
			{children}
		</Text>
	);
};
